// extracted by mini-css-extract-plugin
module.exports = {"viewOnOpenSeaButton":"ViewOnOpenSeaButton_viewOnOpenSeaButton__rTPbF","upperCaseText":"ViewOnOpenSeaButton_upperCaseText__MOZN3"};